import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UserService } from 'shared/services/User/user.service';
import { PaymentService } from 'shared/services/Payment/payment.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { environment } from 'environments/environment';
import { MatDialog } from '@angular/material';
import { ConnectTeamModalComponent } from '../connect-team-modal/connect-team-modal.component';
import { SeatViewModal } from 'shared/reusable/seat-view-modal/seat-view-modal.component';
declare const stripe: any;

@Component({
  selector: 'app-charge-card',
  templateUrl: './charge-card.component.html',
  styleUrls: ['./charge-card.component.css']
})
export class ChargeCardComponent implements OnInit, AfterViewInit {
  cardRef: any;
  holdData: any;
  timerInt: any;
  loading: boolean;
  groupCode: string;
  imageURL: string = environment.URL_TEAM_IMAGES;

  isEmptyGroup: boolean = false;
  doesHaveSeatView: boolean = false;

  isPaymentDisabled = false;

  constructor(
    private us: UserService,
    private router: Router,
    private paymentService: PaymentService,
    private data: DataSharingService,
    private groupService: GroupService,
    private dialog: MatDialog,
    private alertService: AlertPopupService,
    private route: ActivatedRoute,
  ) {
    this.route.queryParams.subscribe(params => { this.groupCode = params.groupCode; });

    this.groupService.isValidGroupv2(this.groupCode).subscribe(res => {
      this.holdData = res;
      // todo- add flag in current split ob for isPaymetDisabeld
      if(this.holdData.season_ticket.total_cost == "0"){
        this.isPaymentDisabled = true; 
      }
      if (!this.holdData) {
        return this.router.navigateByUrl('new-group');
      }
      if (this.holdData.imageData == null) {
        this.doesHaveSeatView = false;
      } else {
        this.doesHaveSeatView = true;
      }
      if (this.holdData['group_members'].length == 0) {
        this.isEmptyGroup = true;
      }
    })

    const elements = stripe.elements();
    const style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };
    this.cardRef = elements.create('card', { style: style });
    this.cardRef.addEventListener('change', (event) => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  ngOnInit() {
    this.data.changeTitle('CHECKOUT');
  }

  back() {
    this.router.navigate(['/new-group']);
  }

  previewSeat() {
    let seatViewURL = this.holdData.image_data;

    const dialog = this.dialog.open(SeatViewModal, {
      width: '80%',
      height: '80%',
      data: {
        seatViewURL: seatViewURL
      }
    });

  }


  ngAfterViewInit(): void {
    this.cardRef.mount('#card-element');
  }

  submitPayment() {
    this.loading = true;
    if(this.isPaymentDisabled == false){
      stripe.createToken(this.cardRef).then((result) => {
        if (result.error) {
          // STRIPE RROR
          // Inform the user if there was an error.
          const errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
          this.loading = false;
        } else {
          // STRIPE SUCCESS, token generated, check if team auth exists
          const token = (result.token.id);
  
          // now check for team auth
          if (this.us.user.team_auths.filter(e => e.team_id_fk === this.holdData.season_ticket.team_id).length > 0) {
            // yes has auth
            this.chargeCard(token);
          } else {
            // no, doesnt have a team auth
            this.loading = false;
            this.alertService.errorAlert('Cannot join group without a connected team account. ');
            // Handles team account connection, refreshes user object and tells user to proceed.
            const dialogRef = this.dialog.open(ConnectTeamModalComponent, {
              width: '600px',
              data: {
                teamId: this.holdData.season_ticket.team_id
              }
            });
          }
        }
      });
    } else {
      // payment disabled, just join the group 
      this.paymentService.joinGroupDeposit("0 ", this.holdData.season_ticket.tm_order_num_out, this.holdData.season_ticket.tm_order_num_out, this.groupCode).subscribe(res => {
        this.loading = false;
        if (res.group.group_id) {
          this.router.navigate(['/groups/waiting-room'], { queryParams: { groupId: res.group.group_id } });
        }
      }, err => {
        this.alertService.errorAlert('There was a problem joining this group. Please try again or contact support if the error persists.');
        this.loading = false;
      });

    }

 
  }

  chargeCard(token) {
    const amt = Number(this.holdData.pre_auth_amount.new_deposit_due);
    setTimeout(() => {
      this.paymentService.joinGroupDeposit(amt, token, this.holdData.season_ticket.tm_order_num_out, this.groupCode).subscribe(res => {
        this.loading = false;
        if (res.group.group_id) {
          this.router.navigate(['/groups/waiting-room'], { queryParams: { groupId: res.group.group_id } });
        }
      }, err => {
        this.alertService.errorAlert('There was a problem joining this group. Please try again or contact support if the error persists.');
        this.loading = false;
      });
    }, 1500);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/charge-card/charge-card.component.ts